import React from 'react';

import { AddIcon, Button } from '@thefarmersfront/kitchen';

import { IRowNode } from 'ag-grid-community';

const ProductSalesCellRenderer = (node: IRowNode, onClick: (node: IRowNode) => void) => {
  const handleClick = () => {
    onClick(node);
  };

  return (
    <Button size="tiny" color="tertiary" onClick={handleClick} leftIcon={<AddIcon size={16} />}>
      판매처
    </Button>
  );
};

export default ProductSalesCellRenderer;
